import request from '@/utils/request'


// 查询设备信息列表
export function listDevice (query) {
  return request({
    url: '/saifuneng/saifuneng-device/list',
    method: 'get',
    params: query
  })
}

// 查询设备信息分页
export function pageDevice (query) {
  return request({
    url: '/saifuneng/saifuneng-device/page',
    method: 'get',
    params: query
  })
}

// 查询设备信息详细
export function getDevice (data) {
  return request({
    url: '/saifuneng/saifuneng-device/detail',
    method: 'get',
    params: data
  })
}

// 新增设备信息
export function addDevice (data) {
  return request({
    url: '/saifuneng/saifuneng-device/add',
    method: 'post',
    data: data
  })
}

// 修改设备信息
export function updateDevice (data) {
  return request({
    url: '/saifuneng/saifuneng-device/edit',
    method: 'post',
    data: data
  })
}

// 删除设备信息
export function delDevice (data) {
  return request({
    url: '/saifuneng/saifuneng-device/delete',
    method: 'post',
    data: data
  })
}

// 删除设备数据信息
export function delDataDevice (data) {
  return request({
    url: '/saifuneng/saifuneng-device-data/one/click/clear',
    method: 'post',
    data: data
  })
}

// 查询管线信息列表
export function listPipeline (query) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/list',
    method: 'get',
    params: query
  })
}

// 查询客户信息列表
export function customList (query) {
  return request({
    url: '/system/user/page',
    method: 'get',
    params: query
  })
}

// 查询设备分类信息列表
export function listDeviceCategorize (query) {
  return request({
    url: '/saifuneng/saifuneng-device-categorize/list',
    method: 'get',
    params: query
  })
}

// 查询设备类型信息列表
export function listDeviceType (query) {
  return request({
    url: '/saifuneng/saifuneng-device-type/list',
    method: 'get',
    params: query
  })
}

// 查询干扰类型信息列表
export function listInterferenceType (query) {
  return request({
    url: '/saifuneng/saifuneng-interference-type/list',
    method: 'get',
    params: query
  })
}

// 查询设备参数信息详情
export function getDeviceParam (data) {
  return request({
    url: '/saifuneng/saifuneng-device-param/detail',
    method: 'get',
    params: data
  })
}

// 查询设备参数信息详情
export function updateDeviceParam (data) {
  return request({
    url: '/saifuneng/saifuneng-device-param/edit',
    method: 'post',
    data: data
  })
}

// 分配设备信息
export function updateDeviceDistribution (data) {
  return request({
    url: '/saifuneng/saifuneng-device/distribution',
    method: 'post',
    data: data
  })
}

// 转移设备信息
export function updateDeviceTransfer (data) {
  return request({
    url: '/saifuneng/saifuneng-device/transfer',
    method: 'post',
    data: data
  })
}

// 租户列表
export function listUserTenant (query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query
  })
}
